import { useMemo } from 'react';
import { RiArrowDownSLine } from 'react-icons/ri';
import type { StudyReportVersion } from '../../../types/studyTimeline';
import { StatusBadge } from '../StatusBadge';
import { STATUS_CONFIG, STATUS_PRIORITY } from '../reportStatusConfig';
import styles from './ReportInlineToggle.module.css';

interface ReportInlineToggleProps {
  reports: StudyReportVersion[];
  expanded: boolean;
  onToggle: () => void;
}

export default function ReportInlineToggle({
  reports,
  expanded,
  onToggle,
}: ReportInlineToggleProps) {
  const uniqueStatuses = useMemo(() => {
    const statusesInReports = new Set(reports.map((r) => r.status));
    return STATUS_PRIORITY.filter((s) => statusesInReports.has(s));
  }, [reports]);

  if (reports.length === 0) return null;

  return (
    <button
      type="button"
      className={styles.toggle}
      onClick={onToggle}
      aria-expanded={expanded}
    >
      <span className={styles.label}>Report:</span>
      <span className={styles.pills}>
        {uniqueStatuses.map((status) => (
          <StatusBadge
            key={status}
            variant={STATUS_CONFIG[status].variant}
            label={STATUS_CONFIG[status].label}
          />
        ))}
      </span>
      <span className={styles.versionCount}>
        {reports.length} {reports.length === 1 ? 'version' : 'versions'}
      </span>
      <RiArrowDownSLine
        className={styles.chevron}
        data-expanded={expanded || undefined}
      />
    </button>
  );
}
